import React, { Component } from 'react';

import { loadCss, loadModules, setDefaultOptions } from 'esri-loader';
import settingsApi from "../../apiV2/settingsApi";
import LayersToggle from "./widgets/LayersToggle";
import LayersPanel from "./widgets/LayersPanel";

import './Basemap.scss';
import MapLayerGroups from "../../modules/Public/Map/components/MapLayerGroups";

const tallinnWMTSYLDURL = 'https://gis.tallinn.ee/arcgis/rest/services/aluskaart_yldine/MapServer/WMTS?';
const tallinnWMTSURL = 'https://gis.tallinn.ee/arcgis/rest/services/aluskaart/MapServer/WMTS?';
const tallinnWMSURL = 'https://gis.tallinn.ee/aluskaardid?';

export const baseMaps = {
    'details': {
        type: 'wmts',
        name: 'Tallinna detailne aluskaart',
        options: [
            {
                url: tallinnWMTSURL,
                // sublayers: [{
                //     name: 'detailne_aluskaart'
                // }]
            }
        ]
    },
    'general': {
        type: 'wmts',
        name: 'Tallinna üldine aluskaart',
        options: [
            {
                url: tallinnWMTSYLDURL,
                // sublayers: [{
                //     name: 'detailne_aluskaart'
                // }]
            }
        ]
    },
    'ortophoto': {
        type: 'wms',
        name: 'Maaameti ortofoto',
        options: [
            {
                url: 'https://kaart.maaamet.ee/wms/alus?',
                sublayers: [{
                    name: 'of10000'
                }],
                version: '1.3.0',
            },
            {
                url: tallinnWMSURL,
                sublayers: [{
                    name: 'aluskaart_hybriid'
                }],
                opacity: 0.75
            }
        ]
    },
    'katastriüksused': {
        type: 'wms',
        name: 'Maaameti Katastriüksus',
        options: [
            {
                url: 'https://kaart.maaamet.ee/wms/alus?',
                sublayers: [{
                    name: 'TOPOYKSUS_6571'
                }],
                version: '1.3.0',
                opacity: 1
            },
            {
                url: 'https://kaart.maaamet.ee/wms/alus?',
                sublayers: [{
                    name: 'TOPOYKSUS_6569'
                }],
                version: '1.3.0',
                opacity: 1
            },
            {
                url: tallinnWMSURL,
                sublayers: [{
                    name: 'detailne_aluskaart'
                }],
                opacity: 0.5
            }
        ]
    },
};

export default class Basemap extends Component {

    state = {
        map: null,
        view: null,
        maps: null,
        showGallery: false,
        customLayers: [],
        savedLayers: []
    };

    constructor(props) {
        super(props);

        this.highlighted = null;
        this.layerListInitConfig = [];
        // By default remember layer list state for user
        this.rememberLayerListState = (this.props.rememberLayerListState !== undefined)
            ? this.props.rememberLayerListState
            : true;
    }

    componentDidMount() {

        loadCss();

        let that = this;

        const wmsMapKeys = Object.keys(baseMaps).filter((key) => ['wms', 'wmts'].indexOf(baseMaps[key].type) > -1);
        const props = this.props;

        if (wmsMapKeys.length > 0) {
            setDefaultOptions({ version: '4.16' });
            loadModules(['esri/Map',
                'esri/views/MapView',
                'esri/Basemap',
                'esri/layers/WMSLayer',
                'esri/layers/WMTSLayer',
                'esri/geometry/SpatialReference',
                'esri/geometry/Extent',
                'esri/config',
                "esri/core/urlUtils",
                'esri/geometry/Point',
                'esri/geometry/Polygon',
                'esri/geometry/Polyline'
            ]).then(([
                Map,
                MapView,
                BaseMap,
                WMSLayer,
                WMTSLayer,
                SpatialReference,
                Extent,
                esriConfig,
                urlUtils,
                Point,
                Polygon,
                Polyline]) => {

                esriConfig.request.interceptors.push({
                    urls: window.location.origin.replace(/:\d+$/, '') + '/proxy',
                    before: function (params) {
                        if (!params.requestOptions.query._bearer) {
                            params.requestOptions.query._bearer = localStorage.user_token;
                        }
                    },
                });

                urlUtils.addProxyRule({
                    urlPrefix: "gis.tallinn.ee",
                    proxyUrl: window.location.origin.replace(/:\d+$/, '') + "/proxy/mirror"
                });

                const spatialReference = new SpatialReference(3301);
                const envelope = new Extent(509628.567963684, 6567958.75707736, 568802.748812045, 6612964.47208879, { wkid: 3301 });

                let maps = [];
                const baseWMSOptions = {
                    spatialReference: spatialReference,
                    version: '1.1.0',
                    fullExtent: envelope,
                    imageFormat: "image/png",
                    imageTransparency: true,
                    copyright: "",
                };
                const baseWMTSOptions = {
                    // spatialReference: spatialReference,
                    version: '1.1.1',
                    fullExtent: envelope,
                    // imageFormat: "image/png",
                    // imageTransparency: true,
                    copyright: "",
                    url: 'https://gis.tallinn.ee/arcgis/rest/services/aluskaart/MapServer/WMTS?'
                };
                wmsMapKeys.forEach((value) => {
                    let baseLayers = null;
                    if (baseMaps[value].type === 'wms') {
                        baseLayers = baseMaps[value].options.map((el) => {
                            return new WMSLayer({ ...baseWMSOptions, ...el })
                        });
                    } else if (baseMaps[value].type === 'wmts') {
                        baseLayers = baseMaps[value].options.map((el) => {
                            return new WMTSLayer({ ...baseWMTSOptions, ...el })
                        });
                    }

                    let options = {
                        baseLayers: baseLayers,
                        title: baseMaps[value].name,
                        id: 'wms_layer_' + value
                    };
                    maps.push(options);
                });
                //find a center point for the map
                var center
                if(props.x && props.y){

                    center = new Point([props.x, props.y], spatialReference)
                }
                else if(this.props.center && this.props.center.point){
                    center = new Point([this.props.center.point.x, this.props.center.point.y], new SpatialReference(parseInt(this.props.center.srid)))
                }
                else{
                    center = new Point([541842.588, 6586585.366], spatialReference)
                }
                // Add map
                const map = new Map({
                    basemap: maps[0]
                });

                const view = new MapView({
                    map: map,
                    container: this.props.id ? this.props.id : 'baseMap',
                    extent: envelope,
                    scale: (this.props.center && this.props.zoom) ? (120000 / this.props.zoom) : ((props.x && props.y) ? (1200) : (120000)),
                    center: center,
                    spatialReference: spatialReference,
                    constraints: {
                        minScale: 240000,
                        maxScale: this.props.maxScale ? this.props.maxScale : 100,
                        rotationEnabled: false
                    }
                });

                if (props.popupDockEnabled) {
                    view.popup.dockEnabled = true;
                    view.popup.dockOptions = {
                        buttonEnabled: true,
                        breakpoint: false,
                    };
                }

                view
                    .when().then(function (layerView) {
                        view.whenLayerView(layerView).then(function (officeLayerView) {
                            that.layerView = officeLayerView;
                        });

                        var handle = layerView.watch("updating", function (newVal, oldVal, prop, target) {
                            if (newVal) {
                                setTimeout(() => {
                                    that.setState({
                                        showGallery: that.props.autoLoadCustomLayersByNames ? true : false
                                    });
                                },1000)
                                handle.remove();
                            }
                        });

                        if (props.pointerDown)
                            view.on("pointer-down", eventHandler);
                        if (props.pointerUp)
                            view.on("pointer-up", eventHandler);

                        function eventHandler(event) {
                            // the hitTest() checks to see if any graphics in the view
                            // intersect the x, y coordinates of the pointer
                            view.hitTest(event).then((e) => {
                                if (props.pointerDown) {
                                    props.pointerDown(e);
                                }
                                if (props.pointerUp) {
                                    props.pointerUp(e);
                                }
                            });
                        }

                        if (props.triggerAction !== undefined) {
                            // Event handler that fires each time an action is clicked
                            view.popup.on("trigger-action", (event) => {
                                props.triggerAction(event, view);
                            });
                        }

                        if (props.setActionVisibility !== undefined) {
                            // Set action visibility
                            view.popup.watch("selectedFeature", async (graphic) => {
                                await props.setActionVisibility(graphic);
                            });
                        }

                        if (props.goToOnLoad) {
                            const geom = props.goToOnLoad,
                                target = {},
                                options = { duration: 0 },
                                wkid = geom.wkid ? geom.wkid : (geom.srid ? geom.srid : 3301),
                                sr = new SpatialReference(parseInt(wkid));

                            if (geom.point && geom.point.x && geom.point.y) {
                                target.geometry = new Point([geom.point.x, geom.point.y], sr);
                                target.scale = 2000;
                            } else if (geom.polygon && Array.isArray(geom.polygon)) {
                                target.geometry = new Polygon({
                                    rings: geom.polygon,
                                    spatialReference: sr,
                                });
                            } else if (geom.polyline && Array.isArray(geom.polyline)) {
                                target.geometry = new Polyline({
                                    paths: geom.polyline,
                                    spatialReference: sr,
                                });
                            }
                            if (target.geometry) {
                                setTimeout(() => {
                                    view.goTo(target, options);
                                }, 2000);
                            }
                        }
                    });



                this.setState({
                    map: map,
                    view: view,
                    maps: maps
                },()=>{
                    //Load all layers automatically
                    if (this.props.autoLoadCustomLayersByNames) {
                        this.setState({
                            autoLoadCustomLayersByNames: this.props.autoLoadCustomLayersByNames,
                            showGallery: true //Need to start loading layers
                        });
                    }
                });

            }).catch((err) => console.error(err));
        } else {
            console.error('Unknown map')
        }
    }

    handleShowGallery = (value) => {
        this.setState({
            showGallery: value
        });
    };

    handleOnLayersChange = (state) => {
        if (this.rememberLayerListState) {
            settingsApi.setUserSetting('layer_list_state', state).then((resp) => {
                if (resp.data) {
                    this.layerListInitConfig = resp.data;
                }
            });
        }
    };

    handleShowCustomLayers = (customLayers) => {
        this.setState({ customLayers });
    };

    render() {
        const { id, className, customGeoJSONLayers } = this.props;
        const children = React.Children.map(this.props.children, (child) => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    map: this.state.map,
                    view: this.state.view,
                });
            }
        });
        return (
            <div id={id ? id : 'baseMap'} className={className ? className : 'baseMap'}>
                {(this.state.map && this.state.view) &&
                    <>
                        <LayersToggle
                            view={this.state.view}
                            map={this.state.map}
                            id={id ? id : 'baseMap'}
                            toggle={this.handleShowGallery}
                            useSettings={this.props.useSettings}
                            buttonState={this.state.showGallery}
                            showOpinfo={this.props.showOpinfo}
                            autoLoadCustomLayersByNames={this.state.autoLoadCustomLayersByNames}
                        />
                        {this.state.showGallery &&
                            <LayersPanel
                                view={this.state.view}
                                maps={this.state.maps}
                                map={this.state.map}
                                customLayers={customGeoJSONLayers}
                                showCustomLayers={this.handleShowCustomLayers}
                                //Load all layers automatically
                                autoLoadCustomLayersByNames={this.state.autoLoadCustomLayersByNames}
                            />
                        }

                        {children}
                        <MapLayerGroups map={this.state.map} groups={this.state.customLayers} />
                    </>
                }
            </div>
        )
    }
}
